import React, { Component } from 'react';
import './newDashboard.css';
import { Form, TextField, SubmitField } from 'react-components-form';
import Chips from 'react-chips';
import ScrollArea from 'react-scrollbar';
import { GithubPicker } from 'react-color';
import UniqId from 'uniqid';

export default class newDashboard extends Component {
  constructor() {
    super();
    this.state = {
      error: '',
      chips: [],
      bgcolor: '#3498db'
    };
  }

  handleThemeChange = color => {
    this.setState({ bgcolor: color.hex, displayColorPicker: false });
  };

  onTagsChange = chips => {
    this.setState({
      chips: chips
    });
  };

  addNewItemToList = model => {
    if (model.name && this.state.chips.length !== 0) {
      this.setState({
        error: ''
      });
      const newDashboardItem = {
        name: model.name,
        id: UniqId(),
        themeColor: this.state.bgcolor,
        tags: this.state.chips,
        creationDate:
          JSON.parse(JSON.stringify(new Date())) || '2019-05-25T09:52:02.777Z',
        content: {
          tasks: {},
          columns: {},
          columnOrder: []
        }
      };
      this.props.addNewDashboard(newDashboardItem);
    } else {
      this.setState({
        error: 'Please fill all the fields !'
      });
    }
  };

  render() {
    return (
      <ScrollArea
        className="new-dashboard-container"
        smoothScrolling={true}
        contentStyle={{ paddingBottom: '20px' }}>
        <h2 className="page-title">Add new dashboard</h2>
        <Form onSubmit={this.addNewItemToList} className="new-item-form">
          <TextField
            name="name"
            label="Name : "
            type="text"
            className="item-textfield"
          />
          <div className="select-tags-chips">
            <span className="select-tags-chips-label">Tags : </span>
            <Chips
              className="chips-container"
              value={this.state.chips}
              onChange={this.onTagsChange}
              suggestions={[
                'Todo',
                'Shopping List',
                'Task List',
                'Procrastinations',
                'Maybe later',
                'Maybe someday'
              ]}
            />
            <span className="input-hint">
              Select a tag or type and press tab to add new !
            </span>
          </div>
          <div className="select-theme-color">
            <span className="select-theme-color-label">Theme :</span>
            <div>
              <GithubPicker
                onChange={this.handleThemeChange}
                triangle="hide"
                colors={[
                  '#1abc9c',
                  '#3498db',
                  '#9b59b6',
                  '#34495e',
                  '#e67e22',
                  '#e74c3c',
                  '#95a5a6',
                  '#2ecc71',
                  '#f39c12',
                  '#8e44ad',
                  '#131418',
                  '#007ee5',
                  '#b92b27',
                  '#cd201f',
                  '#FBC02D',
                  '#6D4C41'
                ]}
              />
            </div>
          </div>
          <SubmitField value="Submit" />
          <span className="form-error">{this.state.error}</span>
        </Form>
      </ScrollArea>
    );
  }
}
